module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAABAklEQVQ4T6WSTUrEQBBGv0oCOcM4W1G8heMBvIAwMy5dhgrkBFkEUuQIjoIX8AAzcwpFcaueIZCkpMSWdn5C1Fp2d73+XneRiFwBeGXme/yjROQcwJhE5AHACYAZM9/+hSkiUwA3AB4pz/NRHMcrIjpW1XmaprYxuMqynBHRQlWf6rqekHUWRXEQhuHyt1Af1rbtWZZlb59Aq6qqRl3XrQEcDUkqInMA1wCegyA4TZLk3TjfQJc0iqKVQQFcMvNil7sPa5pmYsncuR/AIdA+2FbCXfp+0n2avsVWQrdpH+X0iejC1lX1zt5sU3MQcEP/8KvppQ+2V9m/0SVVVXWj0TekH5BYkkHMBJRmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/down_arrow.png
// module id = f7Eb
// module chunks = 10